import React from "react";
import PropTypes from "prop-types";

const StoreMap = ({ latitude, longitude, name, address }) => (
  <>
    {latitude && longitude && name && address ? (
      <div className="mb-6 u-embed u-embed--16p9">
        <iframe
          // Howly smokes longline
          src={`https://maps.google.com/maps?width=100%&height=600&hl=ro&coord=${latitude},${longitude}&q=${encodeURIComponent(
            address
          )}+${encodeURIComponent(name)}&ie=UTF8&t=&z=15&iwloc=B&output=embed`}
          allowFullScreen
        />
      </div>
    ) : null}
  </>
);

StoreMap.propTypes = {
  latitude: PropTypes.string.isRequired,
  longitude: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};

export default StoreMap;
